import React from 'react';
import { Map, Markers } from 'react-amap';
import { observer, inject } from 'mobx-react';
import { Link } from 'react-router-dom';
import styles from './StatisticsMap.less';
import mapIcon from '../../media/imgs/mapIcon.png';
import mapIconActive from '../../media/imgs/mapIcon_active.png';

const toolBarOptions = {
  name: 'ToolBar',
  options: {
    position: 'LB'
  }
};

const clusterEvents = {
  created: markerInstance => {
    markerInstance.forEach(item => {
      item.hide();
    });
  }
};

@inject('statisticsMapStore')
@observer
class StatisticsMap extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      center,
      amapEvents,
      markers,
      onMarkerClick,
      markerList,
      showRightPanel
    } = this.props.statisticsMapStore;
    const clusterOptions = {
      gridSize: 80,
      minClusterSize: 1,
      maxZoom: 20,
      //  当前版本react-amap这个属性名写错了！！！
      renderCluserMarker: ctx => {
        const div = document.createElement('div');
        div.style.position = 'relative';
        div.style.width = '90px';
        div.style.height = '42px';
        div.style.transform = 'translate(-100%, 25%)';

        const span = document.createElement('span');
        span.style.color = '#000';
        span.style.position = 'absolute';
        span.style.fontSize = 12;
        span.style.top = '50%';
        span.style.right = '40px';
        span.style.transform = 'translateY(-60%)';
        span.style.zIndex = 2;
        span.innerText = ctx.count;

        const img = document.createElement('img');
        img.style.width = '90px';
        img.style.height = '42px';
        img.style.position = 'absolute';
        img.style.zIndex = 1;

        const selected = [...this.props.statisticsMapStore.selectedCluster];
        const current = ctx.markers.map(i => i.getExtData().device_id);
        const active = current.every(id => selected.includes(id));
        if (active) {
          this.props.statisticsMapStore.showRightPanel = true;
        }
        // 如果一个聚类包含了所有选中的，说明选中的被聚合到更大的聚类里了，应该清空右侧的列表
        if (
          selected.length &&
          selected.every(m => current.includes(m)) &&
          current.length > selected.length
        ) {
          this.props.statisticsMapStore.showRightPanel = false;
        }

        img.src = active ? mapIconActive : mapIcon;

        div.appendChild(span);
        div.appendChild(img);

        ctx.marker.setContent(div);
      },
      events: {
        click: onMarkerClick
      }
    };

    return (
      <div className={styles.statisticsMapContainer}>
        <Map
          mapStyle={'amap://styles/light'}
          plugins={[toolBarOptions]}
          center={center}
          zoom={7}
          events={amapEvents}
        >
          <Markers
            markers={markers}
            useCluster={clusterOptions}
            events={clusterEvents}
          />
        </Map>
        <div className={styles.markersList}>
          {showRightPanel &&
            [...markerList].map((item, index) => (
              <Link
                key={index}
                to={`/device/info/${item.device_id}`}
                className={styles.listItem}
              >
                <div className={styles.title}>
                  <span className={styles.deviceId}>{item.device_id}</span>
                  {item.online_status ? (
                    <span className={styles.deviceStatusOn}>在线</span>
                  ) : (
                    <span className={styles.deviceStatusOff}>离线</span>
                  )}
                </div>
                <div className={styles.content}>{item.address}</div>
              </Link>
            ))}
        </div>
      </div>
    );
  }
}
export default StatisticsMap;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsMap.js